<div class="container" style="border:1px solid #bebaba">
  <div class="row">
    <div class="col-md-12">

      <a [routerLink]="['/login']">
        <img src="../../../assets/Desktop Class.png" class="img-responsive" style="width:100%; display: block; margin: 0 auto; width: 100%;">
      </a>

      <a [routerLink]="['/login']">
        <img src="../../../assets/main content1.png" class="img-responsive" style="width:100%; display: block; margin: 0 auto; width: 100%;">
      </a>

    </div>
  </div>
  <br />
  <br />
  <div class="row" style="margin-left:5%;margin-right:5%">
    <div class="col-md-12" style="text-align:justify; text-justify:distribute-all-lines; font-weight:bold">
      The information on this website is only a summary of the terms of the Settlement. For more detailed information,
      please review the <a href="../../../assets/docs/AgriStats/Exhibit 1 - Revised 9-4-26 Long Form Notice - Final 09042026.pdf" target="_blank">Long Form Notice</a> and/or the <a href="../../../assets/docs/AgriStats/2026-08-26 - Butterball-JOTS MFPA Order and Notice Schedule.pdf" target="_blank">Settlement Agreements</a>.<br /><br />





      If you are a Settlement Class Member, your legal rights will be affected by this Settlement whether you act or
      do not act.<br /><br />

      <b>
        If you directly purchased certain turkey products from a turkey producer in the United States from January 1,
        2010, through December 31, 2016, you may be eligible to receive benefits from class action settlements.
      </b><br /><br />

      <ul>
        <li>
          There is an update regarding In re Turkey Antitrust Litigation, No. 1:19-cv-08318, a class action lawsuit
          pending in the United States District Court for the Northern District of Illinois in which you previously
          received notices. The purpose of this new notice is to inform you of your rights related to new settlements
          (the “Settlements”) that have been reached on behalf of Direct Purchaser Plaintiffs with Defendants Agri
          Stats, Inc. (“Agri Stats”); House of Raeford Farms, Inc. (“House of Raeford”); Prestage Farms, Inc.,
          Prestage Foods, Inc., and Prestage Farms of South Carolina, LLC (“Prestage” or “the Prestage Defendants”);
          Hormel Foods Corporation and Jennie-O Turkey Store, Inc. (“JOTS”); Butterball, LLC (“Butterball”); Foster
          Farms LLC and Foster Poultry Farms LLC (“Foster Farms” or “the Foster Farms Defendants”); and Perdue Farms,
          Inc. and Perdue Foods LLC (“Perdue” or “the Perdue Defendants”) (together, “the Settling Defendants”). If
          approved by the Court, these Settlements will fully resolve the lawsuit.
        </li>
        <br />
        <li>
          On January 22, 2025, the Court issued an order certifying a class of direct purchasers defined as: “[a]ll
          persons and entities who directly purchased fresh or frozen, uncooked turkey breast, ground turkey, or whole
          bird turkey products (the “Class Products”) from Defendants in the United States during the Class Period.”
          This class of direct purchasers is called the “Certified Class.” The Class Period is January 1, 2010, through
          December 31, 2016.
        </li>
        <br />
        <li>
          The House of Raeford Settlement requires that House of Raeford pay $3,700,000. The Prestage Settlement
          requires that Prestage pay $15,000,000. The JOTS Settlement requires that JOTS pay $37,500,000. The
          Butterball Settlement requires that Butterball pay $34,000,000. The Agri Stats Settlement requires
          that if Agri Stats ever again offers its reporting to the turkey industry (it stopped doing so after
          this lawsuit was filed), then Agri Stats will make extensive changes to its Agri Stats report. House
          of Raeford, Prestage, JOTS, Butterball, and Agri Stats have also agreed to provide specific cooperation
          to Direct Purchaser Plaintiffs in the unlikely event one or more of the Settlements is not granted final
          approval and a trial occurs.
        </li>
        <br />
        <li>
          The Court has not decided whether Agri Stats, House of Raeford, Prestage, JOTS, or Butterball did anything
          wrong, and the Settling Defendants deny any wrongdoing. The Court has decided in favor of Foster Farms and
          Perdue and has granted summary judgment in favor of Foster Farms and Perdue.
        </li>
        <br />
        <li>
          Your legal rights are affected whether you act or do not act. Please read this notice carefully.
        </li>
      </ul>
    </div>
  </div>
  <div class="panel-heading" style="background-color: #27451c; color: white; text-align:center">
    <h2><b>Important Dates</b></h2><br />
  </div>
  <div class="panel-heading" style="background-color: black; color: white; text-align:center; font-weight:bold">
    <div class="row">
      <div class="col-md-4">
        Objection Deadline<br />
        October 30, 2026
      </div>
      <div class="col-md-4">
        Court Hearing Date<br />
        November 24, 2026
      </div>
      <div class="col-md-4">
        Claim Filing Deadline<br />
        October 30, 2026
      </div>
    </div>
  </div>
  <br />
  <br />
  <div class="row" style="margin-left:5%;margin-right:5%; margin-top:3%">
    <div class="col-md-12">
      <div class="table-responsive">
        <table class="table table-bordered">
          <thead>
            <tr>
              <th colspan="3" style="background-color: #0e3870; color: #ffffff; font-weight: bold; font-size: 2.0em; text-align: center;">
                YOUR LEGAL RIGHTS AND OPTIONS IN THIS SETTLEMENT
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td style=" background-color:#eff2f5; text-align:center; font-weight:bold; color:#1e4953; vertical-align: middle; width:25%">
                FILE A CLAIM TO RECEIVE MONEY FROM THE SETTLEMENTS
              </td>
              <td style="background-color:white; color:#3e4144; width:50%">
                To receive money from certain Settlements and the Cooper Farms, Inc. (“Cooper Farms”) and Farbest Foods,
                Inc. (“Farbest Foods”) settlements (“Certified Class settlement proceeds”), you must submit a claim by
                <b>October 30, 2026</b>.<br /><br />

                Even if you already filed a claim in this lawsuit, you must submit another claim if you are a Certified
                Class member and want to be eligible to receive a payment Certified Class settlement proceeds.<br /><br />

                If you are confirmed to be a Certified Class member and file a valid claim, you will be eligible to
                receive payment from the Certified Class settlement proceeds.
              </td>

            </tr>
            <tr>
              <td style=" background-color:#eff2f5; text-align:center; font-weight:bold; color:#1e4953; vertical-align: middle; width:25%">
                OBJECT
              </td>
              <td style="background-color:white; color:#3e4144; width:50%">
                Write to the Court about why you do not like the Settlements. Objections must be postmarked or received by <b>October 30, 2026</b>.
              </td>

            </tr>
            <tr>
              <td style=" background-color:#eff2f5; text-align:center; font-weight:bold; color:#1e4953; vertical-align: middle; width:25%">
                ATTEND THE
                FAIRNESS HEARING
              </td>
              <td style="background-color:white; color:#3e4144; width:50%">
                Ask to speak in Court about the fairness of the Settlement.
              </td>
            </tr>
            <tr>
              <td style=" background-color:#eff2f5; text-align:center; font-weight:bold; color:#1e4953; vertical-align: middle; width:25%">
                DO NOTHING
              </td>
              <td style="background-color:white; color:#3e4144; width:50%">
                If you do nothing, you will benefit from the proposed Settlements through: conduct reform (or changes to Agri Stats’
                future reporting practices); cooperation by Agri Stats, House of Raeford, Prestage, JOTS, and Butterball in response to
                specific requests made by Direct Purchaser Plaintiffs in the unlikely event of their continued prosecution of the
                litigation; and a mutual waiver between the Certified Class and Foster Farms and the Certified Class and Perdue to
                not further litigate this case or seek costs and fees from one another.<br /><br />

                <b>
                  If you do not file a claim and you are a Certified Class member, you will not get a payment from the Certified Class settlement proceeds.
                </b><br /><br />

                The Settlements will resolve your claims against Agri Stats, House of Raeford, Prestage, JOTS, and Butterball.
                You will give up your rights to sue or to continue to sue Agri Stats, House of Raeford, Prestage, JOTS, and
                Butterball about the Released Claims (as defined by the Settlement Agreements). You will further give up your
                rights to appeal the Court’s Summary Judgment decision in favor of Foster Farms and Perdue as to the Certified
                Class’s claims against Foster Farms and Perdue.
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  <br />
  <br />
  <div class="row" style="margin-left: 5%; margin-right: 5%; text-align: justify; text-justify: distribute-all-lines">
    <div class="col-md-12 ">
      <span style="font-weight:bold; text-decoration:underline; font-size:1.3em">Class Definition—You May Be Part of the Class</span><br /><br />

      The Certified Class is defined as:<br /><br />

      <p class="row" style="margin-left: 7%; margin-right: 7%; font-weight:bold">
        All persons and entities who directly purchased fresh or frozen, uncooked turkey breast, ground turkey, or whole bird turkey products
        (“Class Products”) from Defendants in the United States from January 1, 2010, through December 31, 2016 (“Class Period”).<br /><br />
      </p>

      The Certified Class includes persons and entities who purchased Class Products from any of the Defendants. The Court-approved class
      definition, or group of people included, in the Certified Class is different from the settlement classes the Court approved in the
      settlements with Cargill and Tyson.<br /><br />

      <span style="font-weight:bold; text-decoration:underline; font-size:1.3em">Class Products</span><br /><br />

      The Class Products include fresh or frozen, uncooked turkey breast, ground turkey, or whole bird turkey products.<br /><br />

      Turkey breast products do not include: turkey breasts used to make ground turkey, turkey breast tenderloins, organic turkey breast
      products, No Antibiotics Ever (“NAE”) or Antibiotic-Free (“ABF”) turkey breast products, and cooked or ready-to-eat (“RTE”) turkey
      breast products.<br /><br />

      Ground turkey products do not include: ground turkey products made from turkey breasts; ground turkey products made from turkey wings;
      burgers, sausages, and patties; organic ground turkey products NAE or ABF ground turkey products; and cooked or RTE ground turkey
      products.<br /><br />

      Whole bird turkey products do not include: organic turkey whole bird products, NAE or ABF turkey whole bird products, and cooked
      or RTE turkey whole bird products.<br /><br />

      <span style="font-weight:bold; text-decoration:underline; font-size:1.3em">The Settlement Benefits</span><br /><br />

      The Settlement provides for a significant degree of conduct reform that Direct Purchaser Plaintiffs believe will address the concerns
      involving Agri Stats’ turkey industry reports, including requiring that if Agri Stats restarts its turkey industry reports, for a
      period of five years.<br /><br />

      The Foster Farms and Perdue Settlements each provide that neither the Direct Purchaser Plaintiffs nor Foster Farms or Perdue will
      seek to further adjudicate this case. In exchange, the Direct Purchaser Plaintiffs and Foster Farms, and Direct Purchaser Plaintiffs
      and Perdue will not be able to recover any fees or costs against each other in conjunction with this case.<br /><br />

      If the Settlements are approved, House of Raeford will pay $3,700,000, Prestage will pay $15,000,000, JOTS will pay $37,500,000, and
      Butterball will pay $34,000,000 to resolve the claims against them.<br /><br />

      <span style="font-weight:bold; text-decoration:underline; font-size:1.3em">How to Get a Payment</span><br /><br />

      The first claims process was completed in 2025 for the proceeds of settlements with Cargill ($32,500,000) and Tyson ($4,625,000).
      However, due to an appeal of the Court’s final approval order, payments for the first claims process have not yet been paid to the
      settlement class. Once the appeal is resolved, Co-Lead Counsel will ask the Court to approve a plan of distribution and then make
      payments to eligible settlement class members who filed timely and valid claims.<br /><br />

      There is now a second claims process for the proceeds from the settlements with Cooper Farms ($1,687,500), Farbest Foods
      ($1,687,500), House of Raeford ($3,700,000), Prestage ($15,000,000), JOTS ($37,500,000), and Butterball ($34,000,000).
      In total, these settlements total $93,575,000 in recovery for the Certified Class. Any attorneys’ fees, expenses, notice
      and administration costs, and service awards approved by the Court will be deducted from these settlement proceeds before
      they are paid to qualified claimants. The net settlement proceeds will be distributed to eligible Certified Class Members
      who file valid claims by <b>October 30, 2026</b>.<br /><br />

      <span style="font-weight:bold; text-decoration:underline; font-size:1.3em">The Settlement Hearing</span><br /><br />

      The Court will hold a hearing to decide whether to approve the Settlement (the “Fairness Hearing”). you may ask to speak at the
      Fairness Hearing. To do so, you must send a letter saying that it is your “Notice of Intention to Appear in <i>
        In re Turkey
        Antitrust Litigation
      </i>.” Be sure to include your name, the name of your business which purchased Class Products, current
      mailing address, telephone number, and signature. Your Notice of Intention to Appear must be postmarked no later than
      <b>October 30, 2026</b>, and it must be sent to the Clerk of the Court, Co-Lead Class Counsel, and Counsel for Agri Stats,
      House of Raeford, Prestage, Foster Farms, Perdue, JOTS, and Butterball. The address for the Clerk of the Court is: Everett
      McKinley Dirksen U.S. Courthouse, 219 S. Dearborn Street, Chicago, IL 60604. The addresses for Co-Lead Class Counsel and
      Counsel for Agri Stats, House of Raeford, Prestage, Foster Farms, Perdue, JOTS, and Butterball. You cannot ask to speak
      at the hearing if you excluded yourself from the Certified Class.<br /><br />

      The Court will hold the Fairness Hearing remotely via telephone or video conference and may change call-in details or move
      the Fairness Hearing to a later date without providing additional notice to members of the Settlement Class. Updates will
      be posted to this Website.<br /><br />

      <span style="font-weight:bold; text-decoration:underline; font-size:1.3em">Further Information</span><br /><br />

      This website and the <a href="../../../assets/docs/AgriStats/Exhibit 1 - Revised 9-4-26 Long Form Notice - Final 09042026.pdf" target="_blank">Notice</a> summarize the Settlement. For more details regarding this Settlement, please reference the
      <a href="../../../assets/docs/AgriStats/2026-08-26 - Butterball-JOTS MFPA Order and Notice Schedule.pdf" target="_blank">Settlement Agreements</a> or other documents filed in the case under the “Court Documents” link above. You may also contact
      the Settlement Administrator for further information regarding this Settlement.<br /><br />

      <b>Settlement Administrator</b>:<br />
      Turkey Antitrust Litigation<br />
      c/o A.B. Data, Ltd.<br />
      P.O. Box 173015<br />
      Milwaukee, WI  53217<br />
      877-777-9637<br />
      <a href="mailto:info@TurkeyLitigation.com">info@TurkeyLitigation.com</a><br /><br />

      If you have questions, you may call the Turkey Antitrust Litigation Helpline at 877-777-9637 or email <a href="mailto:info@TurkeyLitigation.com">info@TurkeyLitigation.com</a>.
    </div>
  </div>
  <br />

  <br />
  <br />
  <div class="row">
    <div class="col-md-12">
      <a>
        <img src="../../../assets/people graphic.png" class="img-responsive" style="width:100%; display: block; margin: 0 auto; width: 100%;">
      </a>

    </div>
  </div>
</div>

